<script>

import PregressBar from './progress-bar'

export default {
  props: {
    /**
     * 数据
     */
    item: {
      type: Object,
      default: () => {}
    },
    isStock: {
      type: Boolean,
      default: true
    },
    // 库存标签的显示
    // 1 不显示   2 缺货 3 已抢光
    stockTag: {
      type: Number,
      default: 1
    },
    bottom: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PregressBar
  },
  data () {
    return {
      cartItem: this.item
    }
  },
  watch: {
    item () {
      this.cartItem = this.item
    }
  },
  methods: {
  },
  render () {
    // console.log(this.$slots)
    const { cartItem, $style, getLoadSettingStatus } = this
    return (
      <div class={$style['goods-item']}>
        {
          this.$slots.time ? (
            <div class={$style['top']}>
              {this.$slots.time}
            </div>
          ) : null
        }
        {
          this.$slots.time ? (
            <div class={$style['line']}/>
          ) : null
        }
        <div class={$style['center']}>
          <div class={$style['img']}>
            <img src={cartItem.image} alt=""/>
            { this.stockTag === 3
              ? <span class={$style['no-goods']}>已抢光</span> : null}
            { this.stockTag === 2
              ? <span class={$style['no-goods']}>缺货</span> : null}
            { cartItem.type === 8 && cartItem.countDown === 0 && cartItem.presell_stock !== 0
              ? <span class={$style['pre-tag']}>预售中</span> : null}
          </div>
          <div class={$style['info']}>
            <p class={$style['name']}>{cartItem.general_name} {cartItem.norms}</p>
            <p class={$style['company']}>{cartItem.produce_unit}</p>
            {
              cartItem.sale_percent !== undefined ? (<div class={$style['progress-bar']}>
                <pregress-bar value={`${cartItem.sale_percent}%`}/>
                <span class={$style['progress-value']}>已售{cartItem.sale_percent}%</span>
              </div>) : null
            }
            <div class={$style['bottom']}>
              {
                this.getLoginStatus.data.member_id === 0
                  ? (<div class={$style['left']}>
                    <div class={$style['price'] + ' f15'}>会员可见</div>
                  </div>)
                  : cartItem.is_view === 1
                    ? (<div class={$style['left']}><div class={$style['price'] + ' f15'}>区域经销</div> </div>)
                    : (cartItem.is_bargain === 1 && cartItem.tag === 2)
                      ? (<div class={$style['left']}><div class={$style['price'] + ' f15'} v-deliveryPrice>议价商品</div> </div>)
                      : (<div class={$style['left']}><div class={$style['price']} v-deliveryPrice><b>￥</b>{cartItem.for_type === 8 && cartItem.payment_type ? cartItem.deposit : cartItem.jiage}</div>
                        {/* eslint-disable-next-line camelcase */}
                        {cartItem.shanchu_price && getLoadSettingStatus?.data?.is_delivery_flag !== 1
                          ? <div class={$style['del-price']}>¥{cartItem.shanchu_price}</div> : null} </div>)
              }
              {this.$slots.btn}
            </div>
            {cartItem.for_type === 8 ? (<div class={$style['pre-sell']}>预售价：{this.getLoginStatus.data.member_id === 0 ? (<b>会员可见</b>) : cartItem.is_view === 1 ? (<b>区域经销</b>) : this.getLoadSettingStatus.data.is_delivery_flag ? (<b>配送价</b>) : (<b>￥{cartItem.payment_type ? this.float_change(+cartItem.jiage) : cartItem.jiage }</b>)}</div>) : null}
          </div>
        </div>

        <div class={$style['line']}></div>
        {
          this.bottom
            ? (<div class={$style['bottom']}>
              <div class={$style['txt']}>{cartItem.special_content || cartItem.gifts_introduc || cartItem.activity_introduc}
              </div>
            </div>) : null
        }
      </div>
    )
  }
}
</script>
<style module lang="scss">
  .goods-item {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    box-shadow: 0px 2px 10px 0px rgba(230, 229, 229, 0.7);
    margin-bottom: 10px;
    .top {
      height: 35px;
      padding: 0 10px;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      span {
        min-width: 15px;
        height: 15px;
        border: 1px solid rgba(229, 229, 229, 1);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: 0 6px;
        border-radius: 4px;
        color: #EB2525;
      }
    }
    .center {
      display: flex;
      flex: 1;
      padding: 15px;

      .img {
        width: 75px;
        height: 75px;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
        img {
          width: 100%;
        }
        .no-goods{
          color: #FFFFFF;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 16px;
          background:rgba(125,125,125,0.6);
          border-radius:0px 0px 4px 4px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .pre-tag{
          position: absolute;
          left: 0;
          top:0;
          background: #FF5B7A;
          opacity: 0.8;
          width:45px;
          height:18px;
          color:#fff;
          font-size: 10px;
          display: flex;
          @include center();
          border-radius: 9px;
        }
      }

      .info {
        margin-left: 25px;
        flex: 1;
        .name {
          color:rgba(51,51,51,1);
          font-size: 15px;
          font-weight: 500;
          @include ell(2);
        }

        .company {
          color:rgba(119,119,119,1);
          font-size: 12px;
          font-weight: 400;
          @include ell();
        }
        .bottom{
          display: flex;
          margin-top: 10px;
          justify-content: space-between;
          .left{
            display: flex;
          }
          .price{
            color: #EA2727;
            font-size: 18px;
            b{
              font-size: 12px;
            }
          }
          .del-price{
            text-decoration: line-through;
            @include center();
            color: #A0A0A0;
            font-size: 12px!important;
            >span{
              font-size: 12px!important;
            }
            margin-left: 5px;
          }

        }
      }
    }
    >.bottom{
      height: 30px;
      display: flex;
      align-items: center;
      color: #EC5F63;
      padding: 0 15px;
      .tag{
        width: 30px;
        height: 15px;
        background: #EC5F63;
        color: #ffffff;
        margin: 0 5px 0 0;
        @include center();
        flex-shrink:0;
      }
      .txt{
        @include ell();
      }
    }
  }
  .progress-bar{
    display: flex;
    margin-top: 5px;
    align-items: center;
    .progress-value{
      color: #999999;
      font-size: 12px;
      margin-left: 15px;
    }
  }
  .line {
    height: 1px;
    width: 100%;
    background: rgba(229, 229, 229, 1);
    transform: scaleY(0.5);
  }
  // .deposit-tag{
  //   width: 37px;
  //   height:15px ;
  //   background: url("./../../../assets/img/pre-sell/deposit-tag.png") no-repeat;
  //   background-size: 100% 100%;
  // }
  .pre-sell{
    color: #777777;
    font-size: 12px;
    b{
      color: #F84F4F;
    }
  }
</style>
